import { COMPANY } from "../pages/Company";

const NAVY = "#13274d", BLUE = "#2F6EEA", INK = "#1d1d1f", GREY = "#606066", LIGHT = "#e1e4eb", SOFT = "#f5f6f8";
const FONT = "-apple-system, BlinkMacSystemFont, 'SF Pro Text', Inter, system-ui, sans-serif";
const W = 1400, PAD = 56;

function wrap(g, text, max) {
  const out = []; let line = "";
  for (const w of String(text || "").split(/\s+/)) { const t = line ? `${line} ${w}` : w; if (g.measureText(t).width > max && line) { out.push(line); line = w; } else line = t; }
  if (line) out.push(line);
  return out;
}

// Letterhead creative drawn from structured rows (no screenshots): header band with the wordmark, caption, aligned table, total, notes and company footer. Returns PNG/JPEG data URLs.
export function buildEstimateCard({ title, subtitle, url, head, rows, total, highlight = -1, note = "" }) {
  const cols = [0.4, 0.24, 0.17, 0.19].map((f) => Math.round((W - PAD * 2) * f));
  const x = [PAD, PAD + cols[0], PAD + cols[0] + cols[1], PAD + cols[0] + cols[1] + cols[2], W - PAD];
  const measure = document.createElement("canvas").getContext("2d");
  measure.font = `400 17px ${FONT}`;
  const rowH = rows.map((r) => 34 + (r[1] ? Math.max(1, wrap(measure, r[1], cols[1] - 24).length) * 20 : 0) + (r[4] ? 20 : 0));
  const header = 128, caption = 112, thead = 44, totalH = total ? 78 : 0, noteH = note ? 56 : 0, footer = 150;
  const H = header + caption + thead + rowH.reduce((a, b) => a + b, 0) + totalH + noteH + 40 + footer;
  const c = document.createElement("canvas"); c.width = W; c.height = H;
  const g = c.getContext("2d");
  g.textBaseline = "alphabetic";
  g.fillStyle = "#ffffff"; g.fillRect(0, 0, W, H);
  // header band: wordmark only
  g.fillStyle = NAVY; g.fillRect(0, 0, W, header - 6);
  g.fillStyle = BLUE; g.fillRect(0, header - 6, W, 6);
  g.font = `700 44px ${FONT}`; g.fillStyle = BLUE; g.fillText("V", PAD, 78);
  g.fillStyle = "#ffffff"; g.fillText("istolane", PAD + g.measureText("V").width, 78);
  g.font = `400 17px ${FONT}`; g.fillStyle = "#c8d0e1"; g.textAlign = "right";
  g.fillText(COMPANY.legal, W - PAD, 50); g.fillText(COMPANY.address.join(", "), W - PAD, 74); g.fillText(`${COMPANY.email} · ${COMPANY.phone}`, W - PAD, 98);
  g.textAlign = "left";
  // caption
  g.font = `600 30px ${FONT}`; g.fillStyle = INK; g.fillText(title, PAD, header + 46);
  g.font = `400 18px ${FONT}`; g.fillStyle = GREY; g.fillText(subtitle, PAD, header + 78);
  // table head
  let y = header + caption;
  g.fillStyle = SOFT; g.fillRect(PAD, y, W - PAD * 2, thead);
  g.font = `600 15px ${FONT}`; g.fillStyle = GREY;
  head.forEach((h, i) => { g.textAlign = i === 3 ? "right" : "left"; g.fillText(h, i === 3 ? x[4] - 16 : x[i] + 16, y + 28); });
  y += thead;
  rows.forEach((r, i) => {
    const h = rowH[i];
    if (i === highlight) { g.fillStyle = "rgba(47,110,234,0.06)"; g.fillRect(PAD, y, W - PAD * 2, h); }
    g.fillStyle = LIGHT; g.fillRect(PAD, y + h - 1, W - PAD * 2, 1);
    g.textAlign = "left"; g.font = `${i === highlight ? 600 : 500} 18px ${FONT}`; g.fillStyle = INK; g.fillText(r[0], x[0] + 16, y + 27);
    if (r[4]) { g.font = `400 14px ${FONT}`; g.fillStyle = GREY; g.fillText(r[4], x[0] + 16, y + 48); }
    g.font = `400 17px ${FONT}`; g.fillStyle = GREY;
    wrap(g, r[1], cols[1] - 24).forEach((l, k) => g.fillText(l, x[1] + 16, y + 27 + k * 20));
    g.fillText(r[2] || "", x[2] + 16, y + 27);
    g.textAlign = "right"; g.font = `600 18px ${FONT}`; g.fillStyle = INK; g.fillText(r[3] || "", x[4] - 16, y + 27);
    y += h;
  });
  if (total) {
    g.fillStyle = NAVY; g.fillRect(PAD, y + 12, W - PAD * 2, totalH - 12);
    g.textAlign = "left"; g.font = `600 18px ${FONT}`; g.fillStyle = "#ffffff"; g.fillText(total[0], x[0] + 16, y + 52);
    g.textAlign = "right"; g.font = `700 28px ${FONT}`; g.fillText(total[1], x[4] - 16, y + (total[2] ? 48 : 54));
    if (total[2]) { g.font = `400 14px ${FONT}`; g.fillStyle = "#c8d0e1"; g.fillText(total[2], x[4] - 16, y + 68); }
    y += totalH;
  }
  if (note) { g.textAlign = "left"; g.font = `400 15px ${FONT}`; g.fillStyle = GREY; wrap(g, note, W - PAD * 2).slice(0, 2).forEach((l, k) => g.fillText(l, PAD, y + 34 + k * 20)); y += noteH; }
  // footer
  const fy = H - footer;
  g.textAlign = "left"; g.fillStyle = LIGHT; g.fillRect(PAD, fy, W - PAD * 2, 2);
  g.font = `400 15px ${FONT}`; g.fillStyle = GREY;
  g.fillText(`${COMPANY.legal} · ${COMPANY.address.join(", ")}`, PAD, fy + 36);
  g.fillText(`${COMPANY.email} · ${COMPANY.phone} · vistolane.com`, PAD, fy + 60);
  g.fillText("An estimate from the live price book. Specialist-track files are quoted per file before work starts; government fees are paid by the applicant.", PAD, fy + 84);
  if (url) { g.fillStyle = BLUE; const u = url.replace(/^https?:\/\//, ""); g.fillText(`Open the live estimate: ${u.length > 120 ? `${u.slice(0, 117)}…` : u}`, PAD, fy + 110); }
  return { dataUrl: c.toDataURL("image/png"), jpeg: c.toDataURL("image/jpeg", 0.85), width: W, height: H };
}

export async function estimateCardPdf(card, filename) {
  const { jsPDF } = await import("jspdf");
  const landscape = card.width > card.height;
  const doc = new jsPDF({ unit: "pt", format: "a4", orientation: landscape ? "landscape" : "portrait" });
  const PW = doc.internal.pageSize.getWidth(), PH = doc.internal.pageSize.getHeight(), M = 24;
  const r = Math.min((PW - M * 2) / card.width, (PH - M * 2) / card.height);
  const w = card.width * r, h = card.height * r;
  doc.addImage(card.jpeg, "JPEG", (PW - w) / 2, (PH - h) / 2, w, h);
  doc.save(filename);
}

export function downloadDataUrl(dataUrl, filename) {
  const a = document.createElement("a"); a.href = dataUrl; a.download = filename; a.click();
}

// Native share sheet with the image when the device supports files; otherwise save the PNG locally so it can be attached.
export async function shareOrSaveCard(card, filename, text) {
  try {
    const blob = await (await fetch(card.dataUrl)).blob();
    const file = new File([blob], filename, { type: "image/png" });
    if (navigator.canShare?.({ files: [file] })) { await navigator.share({ files: [file], text }); return "shared"; }
  } catch (e) { if (e?.name === "AbortError") return "cancelled"; }
  downloadDataUrl(card.dataUrl, filename);
  return "saved";
}
